import { Theme } from '@mui/material/styles'

const muiList = (_theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        outline: 0
      }
    }
  }
}

export default muiList
